import { render, staticRenderFns } from "./rssModulePage.vue?vue&type=template&id=7ab83638&scoped=true&"
import script from "./rssModulePage.vue?vue&type=script&lang=js&"
export * from "./rssModulePage.vue?vue&type=script&lang=js&"
import style0 from "./rssModulePage.vue?vue&type=style&index=0&id=7ab83638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab83638",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCol,VDivider,VHover,VIcon,VRow})
